class SpinnerServiceImpl {
  static instance = null;

  static getInstance() {
    if (!SpinnerServiceImpl.instance) {
      SpinnerServiceImpl.instance = new SpinnerServiceImpl();
    }
    return SpinnerServiceImpl.instance;
  }

  show() {
    let spinner = document.getElementById("spinner");
    if (spinner) {
      spinner.style.display = "block";
    }
  }

  hide() {
    let spinner = document.getElementById("spinner");
    if (spinner) {
      spinner.style.display = "none";
    }
  }
}

export const SpinnerService = SpinnerServiceImpl.getInstance();
